module.exports = __webpack_public_path__ + "img/2.97275126.jpg";